<template lang="html">
  <div>
    <div class="row">
      <div class="col-md-12">
        <f7-searchbar class="search"
        cancel-link="Cancel"
        placeholder="Search in Drafts"
        search-list="#draft-list"
        @searchbar:search="onSearch"
        @searchbar:clear="onClear">
        </f7-searchbar>
      </div>
    </div>
    <div class="layoutSubtitle"/>

    <cm-draft-list v-bind:drafts="drafts"></cm-draft-list>
    <cm-pagination
      :firstIndex="draftsPaginationObject.firstIndex"
      :maxResultsByPage="draftsPaginationObject.maxResults"
      :nbResultsTotal="draftsPaginationObject.nbResultsTotal"
      :refreshEvent="draftsPaginationObject.refresh"
      ></cm-pagination>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import DraftList from '../DPDraftList.vue'
import pagination from '@/components/common/pagination.vue'
import moment from 'moment'

export default {
  name: 'dp-drafts-send',
  components: {
    'cm-draft-list': DraftList,
    'cm-pagination': pagination
  },
  data: () => {
    return {
      drafts: [],
      draftsSelected: [],
      filterBy: '',
      draftsPaginationObject: {}
    }
  },
  created () {
    let that = this
    // Pagination Params
    that.draftsPaginationObject['firstIndex'] = 1
    that.draftsPaginationObject['maxResults'] = 10
    that.draftsPaginationObject['nbResultsTotal'] = 0
    that.draftsPaginationObject['refresh'] = 'refresh-cache-draft-paging'

    // Refresh Params
    this.$bus.$off('refresh-cache-draft-paging')
    this.$bus.$on('refresh-cache-draft-paging', (index) => {
      that.getDraft(index)
    })

    that.getDraft()
  },
  beforeDestroy () {
    this.drafts = []
    this.draftsSelected = []
    this.filterBy = ''
    this.draftsPaginationObject = {}
  },
  methods: {
    getDraft: function (index = 1) {
      this.$f7.showIndicator()
      let that = this
      this.draftsPaginationObject.firstIndex = index
      var draftListOnPage = []
      var draftList = {}
      let params = {
        idAccount: this.$engine.user.get().id,
        idUserAccount: this.$engine.user.userAccountId
      }
      this.$engine.dpDrafts.getDrafts(params).then(response => {
        that.status = response.status
        var groups = []
        let nbElement = 0
        this.$engine.accounts.fetchGroup().then(resp => {
          if (response.status === 200) {
            this.draftsPaginationObject.nbResults = 0
            draftList = response.data.drafts
            for (var i in draftList) {
              if (draftList[i].draftName.toLowerCase().includes(this.filterBy.toLowerCase())) {
                nbElement++
                // console.log('paramètres de drafts')
                // console.log(this.draftsPaginationObject)
                if (this.draftsPaginationObject.firstIndex <= nbElement && nbElement < (this.draftsPaginationObject.firstIndex + this.draftsPaginationObject.maxResults)) {
                  if ((draftList[i].isValidated === '0' || draftList[i].isValidated === '2') &&
                      (draftList[i].isComplete === '1')) {
                    /* TLV 01/2020
                      On vérifie si l'id team du draft correspond bien à l'id team de l'utilisateur.
                      On obtient un tableau avec 1 élément si l'utilisateur est dans la team du draft.
                      this.$engine.accounts.getMembersGroup() récupère toutes les teams et les groupes de chaque team de l'entreprise
                      (même celles dont l'utilisateur actuel n'est pas inclus) */
                    let teams = this.$engine.accounts.getMembersGroup().filter(team => { return team.id_team === draftList[i].idTeam })
                    // On récupère les groupes de la team du draft, si l'id team du brouillon fait partie des teams de l'utilisateur
                    if (teams.length === 1) {
                      let groups = teams[0].groups
                      /* On recherche le groupe commun à la team de l'utilisateur et la team du draft qui n'a pas déjà validé le brouillon
                        Si le draft a déjà été validé, alors l'idAccount ne vaut plus '' mais la valeur du compte l'ayant validé */
                      groups = groups.filter(group => draftList[i].validators.filter(vgroup => { return vgroup.idAccount === '' }).map(vgroup => { return vgroup.groupId }).includes(group.id_group))
                      // console.log(groups)
                      /* L'icône de validation n'est affichée que pour le groupe de level le plus faible
                        (Par ex. si les comptables peuvent valider mais pas les groupes en-dessous hiérarchiquement, alors seuls eux voient l'icône) */
                      let minLevelValue = Math.min.apply(Math, groups.map(function (g) { return g.level }))
                      // Pour chacun des groupes de validation trouvés dans le draft, on regarde si l'utilisateur actuel est dedans
                      groups.forEach(group => {
                        if (group.members.map(member => { return member.id_user_account }).includes(this.$engine.user.userAccountId.toString())) {
                          // On vérifie si l'icône "Validate Draft" s'affiche sur la liste de brouillons générale (pour le groupe le plus faible de droits pouvant valider uniquement)
                          if (parseInt(group.level) === minLevelValue) {
                            draftList[i].printValidateDraftIcon = true
                          }
                          // On vérifie si l'utilisateur peut valider le brouillon une fois qu'il aura cliqué dessus
                          draftList[i].isValidator = true
                          draftList[i].idGroup = group.id_group
                        }
                      })
                    }
                  }
                  draftList[i].validatorsGroups = groups
                  this.draftsPaginationObject.nbResults++
                  draftListOnPage.push(draftList[i])
                  draftListOnPage.sort()
                }
              }
            }
            this.draftsPaginationObject.nbResultsTotal = nbElement
            this.drafts = draftListOnPage
            this.$bus.emit('refresh-cache-paging-template', this.draftsPaginationObject)
            that.$f7.hideIndicator()
          }
        })
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    refreshDrafts () {
      this.getDraft()
    },
    onSearch: function (query, found) {
      this.filterBy = query
      this.getDraft()
    },
    onClear: function () {
      this.filterBy = ''
    },
    extractCSV () {
      let firstLine = 'draftName;Status\r\n'
      let lines = ''
      for (let datas in this.drafts) {
        lines += this.drafts[datas]['draftName'] + ';'
        var status = DraftList.methods.getLabelStatus(this.drafts[datas])
        lines += status + '\r\n'
      }

      let data = firstLine + lines
      let today = moment()

      const linkSource = 'data:text/csv;charset:utf-8,' + data
      const downloadLink = document.createElement('a')
      const fileName = 'draftDirectPayments' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Drafts.vue?359ab090